function cov_14rmx9vrvj() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/ui/OrganizationsDropdown.tsx";
    var hash = "504945599dd7e8b7881ec17eddef8bc57115017d";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/ui/OrganizationsDropdown.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 15,
                    column: 20
                },
                end: {
                    line: 15,
                    column: 49
                }
            },
            "1": {
                start: {
                    line: 17,
                    column: 69
                },
                end: {
                    line: 143,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 29,
                    column: 15
                },
                end: {
                    line: 29,
                    column: 31
                }
            },
            "3": {
                start: {
                    line: 30,
                    column: 18
                },
                end: {
                    line: 30,
                    column: 31
                }
            },
            "4": {
                start: {
                    line: 31,
                    column: 20
                },
                end: {
                    line: 35,
                    column: 2
                }
            },
            "5": {
                start: {
                    line: 33,
                    column: 3
                },
                end: {
                    line: 33,
                    column: 68
                }
            },
            "6": {
                start: {
                    line: 36,
                    column: 27
                },
                end: {
                    line: 36,
                    column: 40
                }
            },
            "7": {
                start: {
                    line: 37,
                    column: 42
                },
                end: {
                    line: 37,
                    column: 75
                }
            },
            "8": {
                start: {
                    line: 38,
                    column: 21
                },
                end: {
                    line: 38,
                    column: 56
                }
            },
            "9": {
                start: {
                    line: 40,
                    column: 2
                },
                end: {
                    line: 80,
                    column: 5
                }
            },
            "10": {
                start: {
                    line: 43,
                    column: 5
                },
                end: {
                    line: 43,
                    column: 56
                }
            },
            "11": {
                start: {
                    line: 50,
                    column: 19
                },
                end: {
                    line: 50,
                    column: 65
                }
            },
            "12": {
                start: {
                    line: 59,
                    column: 7
                },
                end: {
                    line: 61,
                    column: 8
                }
            },
            "13": {
                start: {
                    line: 69,
                    column: 7
                },
                end: {
                    line: 71,
                    column: 8
                }
            },
            "14": {
                start: {
                    line: 83,
                    column: 29
                },
                end: {
                    line: 101,
                    column: 2
                }
            },
            "15": {
                start: {
                    line: 84,
                    column: 26
                },
                end: {
                    line: 84,
                    column: 43
                }
            },
            "16": {
                start: {
                    line: 86,
                    column: 2
                },
                end: {
                    line: 100,
                    column: 3
                }
            },
            "17": {
                start: {
                    line: 87,
                    column: 20
                },
                end: {
                    line: 87,
                    column: 35
                }
            },
            "18": {
                start: {
                    line: 88,
                    column: 21
                },
                end: {
                    line: 88,
                    column: 39
                }
            },
            "19": {
                start: {
                    line: 90,
                    column: 3
                },
                end: {
                    line: 90,
                    column: 16
                }
            },
            "20": {
                start: {
                    line: 91,
                    column: 3
                },
                end: {
                    line: 91,
                    column: 36
                }
            },
            "21": {
                start: {
                    line: 92,
                    column: 3
                },
                end: {
                    line: 92,
                    column: 33
                }
            },
            "22": {
                start: {
                    line: 93,
                    column: 3
                },
                end: {
                    line: 93,
                    column: 33
                }
            },
            "23": {
                start: {
                    line: 95,
                    column: 3
                },
                end: {
                    line: 99,
                    column: 4
                }
            },
            "24": {
                start: {
                    line: 96,
                    column: 4
                },
                end: {
                    line: 96,
                    column: 28
                }
            },
            "25": {
                start: {
                    line: 98,
                    column: 4
                },
                end: {
                    line: 98,
                    column: 44
                }
            },
            "26": {
                start: {
                    line: 103,
                    column: 20
                },
                end: {
                    line: 105,
                    column: 2
                }
            },
            "27": {
                start: {
                    line: 104,
                    column: 2
                },
                end: {
                    line: 104,
                    column: 18
                }
            },
            "28": {
                start: {
                    line: 107,
                    column: 25
                },
                end: {
                    line: 120,
                    column: 2
                }
            },
            "29": {
                start: {
                    line: 108,
                    column: 2
                },
                end: {
                    line: 119,
                    column: 5
                }
            },
            "30": {
                start: {
                    line: 109,
                    column: 20
                },
                end: {
                    line: 109,
                    column: 25
                }
            },
            "31": {
                start: {
                    line: 111,
                    column: 3
                },
                end: {
                    line: 118,
                    column: 5
                }
            },
            "32": {
                start: {
                    line: 114,
                    column: 20
                },
                end: {
                    line: 114,
                    column: 46
                }
            },
            "33": {
                start: {
                    line: 123,
                    column: 2
                },
                end: {
                    line: 128,
                    column: 10
                }
            },
            "34": {
                start: {
                    line: 130,
                    column: 1
                },
                end: {
                    line: 142,
                    column: 3
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 17,
                        column: 69
                    },
                    end: {
                        line: 17,
                        column: 70
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 6
                    },
                    end: {
                        line: 143,
                        column: 1
                    }
                },
                line: 27
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 32,
                        column: 2
                    },
                    end: {
                        line: 32,
                        column: 3
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 45
                    },
                    end: {
                        line: 34,
                        column: 3
                    }
                },
                line: 32
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 42,
                        column: 13
                    },
                    end: {
                        line: 42,
                        column: 14
                    }
                },
                loc: {
                    start: {
                        line: 43,
                        column: 5
                    },
                    end: {
                        line: 43,
                        column: 56
                    }
                },
                line: 43
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 50,
                        column: 13
                    },
                    end: {
                        line: 50,
                        column: 14
                    }
                },
                loc: {
                    start: {
                        line: 50,
                        column: 19
                    },
                    end: {
                        line: 50,
                        column: 65
                    }
                },
                line: 50
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 58,
                        column: 15
                    },
                    end: {
                        line: 58,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 59,
                        column: 7
                    },
                    end: {
                        line: 61,
                        column: 8
                    }
                },
                line: 59
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 68,
                        column: 15
                    },
                    end: {
                        line: 68,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 7
                    },
                    end: {
                        line: 71,
                        column: 8
                    }
                },
                line: 69
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 83,
                        column: 29
                    },
                    end: {
                        line: 83,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 83,
                        column: 54
                    },
                    end: {
                        line: 101,
                        column: 2
                    }
                },
                line: 83
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 103,
                        column: 20
                    },
                    end: {
                        line: 103,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 103,
                        column: 45
                    },
                    end: {
                        line: 105,
                        column: 2
                    }
                },
                line: 103
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 107,
                        column: 25
                    },
                    end: {
                        line: 107,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 107,
                        column: 51
                    },
                    end: {
                        line: 120,
                        column: 2
                    }
                },
                line: 107
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 108,
                        column: 24
                    },
                    end: {
                        line: 108,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 108,
                        column: 42
                    },
                    end: {
                        line: 119,
                        column: 3
                    }
                },
                line: 108
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 114,
                        column: 14
                    },
                    end: {
                        line: 114,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 114,
                        column: 20
                    },
                    end: {
                        line: 114,
                        column: 46
                    }
                },
                line: 114
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 33,
                        column: 10
                    },
                    end: {
                        line: 33,
                        column: 67
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 33,
                            column: 61
                        },
                        end: {
                            line: 33,
                            column: 62
                        }
                    }, {
                        start: {
                            line: 33,
                            column: 65
                        },
                        end: {
                            line: 33,
                            column: 67
                        }
                    }],
                line: 33
            },
            "1": {
                loc: {
                    start: {
                        line: 37,
                        column: 42
                    },
                    end: {
                        line: 37,
                        column: 75
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 37,
                            column: 42
                        },
                        end: {
                            line: 37,
                            column: 54
                        }
                    }, {
                        start: {
                            line: 37,
                            column: 58
                        },
                        end: {
                            line: 37,
                            column: 75
                        }
                    }],
                line: 37
            },
            "2": {
                loc: {
                    start: {
                        line: 55,
                        column: 4
                    },
                    end: {
                        line: 77,
                        column: 4
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 55,
                            column: 4
                        },
                        end: {
                            line: 55,
                            column: 15
                        }
                    }, {
                        start: {
                            line: 56,
                            column: 4
                        },
                        end: {
                            line: 76,
                            column: 7
                        }
                    }],
                line: 55
            },
            "3": {
                loc: {
                    start: {
                        line: 79,
                        column: 4
                    },
                    end: {
                        line: 79,
                        column: 52
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 79,
                            column: 4
                        },
                        end: {
                            line: 79,
                            column: 28
                        }
                    }, {
                        start: {
                            line: 79,
                            column: 32
                        },
                        end: {
                            line: 79,
                            column: 52
                        }
                    }],
                line: 79
            },
            "4": {
                loc: {
                    start: {
                        line: 86,
                        column: 2
                    },
                    end: {
                        line: 100,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 86,
                            column: 2
                        },
                        end: {
                            line: 100,
                            column: 3
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 86
            },
            "5": {
                loc: {
                    start: {
                        line: 95,
                        column: 3
                    },
                    end: {
                        line: 99,
                        column: 4
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 95,
                            column: 3
                        },
                        end: {
                            line: 99,
                            column: 4
                        }
                    }, {
                        start: {
                            line: 97,
                            column: 10
                        },
                        end: {
                            line: 99,
                            column: 4
                        }
                    }],
                line: 95
            },
            "6": {
                loc: {
                    start: {
                        line: 123,
                        column: 2
                    },
                    end: {
                        line: 128,
                        column: 10
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 124,
                            column: 3
                        },
                        end: {
                            line: 127,
                            column: 6
                        }
                    }, {
                        start: {
                            line: 128,
                            column: 6
                        },
                        end: {
                            line: 128,
                            column: 10
                        }
                    }],
                line: 123
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0
        },
        b: {
            "0": [0, 0],
            "1": [0, 0],
            "2": [0, 0],
            "3": [0, 0],
            "4": [0, 0],
            "5": [0, 0],
            "6": [0, 0]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "504945599dd7e8b7881ec17eddef8bc57115017d"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_14rmx9vrvj = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_14rmx9vrvj();
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Dropdown, DropdownButton } from 'vio-components';
import { ROLES, ROUTES } from 'vio-constants';
import { isJSONStringEqual } from 'vio-libs';
const consumerAPI = (cov_14rmx9vrvj().s[0]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.consumer_api_rollout);
cov_14rmx9vrvj().s[1]++;
const OrganizationsDropdown = ({ manageUsers, organizations, organization, requestLocations, requestOrgNetworkInterfaces, setUserRoles, allUserRoles, resetMenus, setOrganization }) => {
    cov_14rmx9vrvj().f[0]++;
    const { t } = (cov_14rmx9vrvj().s[2]++, useTranslation());
    const navigate = (cov_14rmx9vrvj().s[3]++, useNavigate());
    const sortedOrgs = (cov_14rmx9vrvj().s[4]++, [...organizations].sort((firstOrganization, secondOrganization) => {
        cov_14rmx9vrvj().f[1]++;
        cov_14rmx9vrvj().s[5]++;
        return firstOrganization.name > secondOrganization.name ? (cov_14rmx9vrvj().b[0][0]++, 1) : (cov_14rmx9vrvj().b[0][1]++, -1);
    }));
    const firstOrganization = (cov_14rmx9vrvj().s[6]++, sortedOrgs[0]);
    const { name, slug: organizationSlug } = (cov_14rmx9vrvj().s[7]++, (cov_14rmx9vrvj().b[1][0]++, organization) || (cov_14rmx9vrvj().b[1][1]++, firstOrganization));
    const routeParams = (cov_14rmx9vrvj().s[8]++, `?organization=${organizationSlug}`);
    const orgItems = (cov_14rmx9vrvj().s[9]++, React.createElement(React.Fragment, null, React.createElement(Dropdown.Item, {
        onClick: () => {
            cov_14rmx9vrvj().f[2]++;
            cov_14rmx9vrvj().s[10]++;
            return redirectTo(`${ROUTES.ACTIVITY_LOGS}${routeParams}`);
        }
    }, t('ActivityLogs:ACTIVITY_LOGS')), React.createElement(Dropdown.Item, {
        onClick: () => {
            cov_14rmx9vrvj().f[3]++;
            cov_14rmx9vrvj().s[11]++;
            return redirectTo(`${ROUTES.CONTACTS}${routeParams}`);
        }
    }, t('CONTACTS')), (cov_14rmx9vrvj().b[2][0]++, manageUsers) && (cov_14rmx9vrvj().b[2][1]++, React.createElement(React.Fragment, null, React.createElement(Dropdown.Item, {
        onClick: () => {
            cov_14rmx9vrvj().f[4]++;
            cov_14rmx9vrvj().s[12]++;
            return redirectTo(`${ROUTES.MANAGE}${ROUTES.USERS}${routeParams}`);
        }
    }, t('USERS')), React.createElement(Dropdown.Item, {
        onClick: () => {
            cov_14rmx9vrvj().f[5]++;
            cov_14rmx9vrvj().s[13]++;
            return redirectTo(`${ROUTES.MANAGE}${ROUTES.ROLES}${routeParams}`);
        }
    }, t('ROLES')))), (cov_14rmx9vrvj().b[3][0]++, organizations.length > 1) && (cov_14rmx9vrvj().b[3][1]++, React.createElement(Dropdown.Divider, null))));
    cov_14rmx9vrvj().s[14]++;
    const onOrganizationClick = index => {
        cov_14rmx9vrvj().f[6]++;
        const newOrganization = (cov_14rmx9vrvj().s[15]++, sortedOrgs[index]);
        cov_14rmx9vrvj().s[16]++;
        if (!isJSONStringEqual(organization, newOrganization)) {
            cov_14rmx9vrvj().b[4][0]++;
            const { slug } = (cov_14rmx9vrvj().s[17]++, newOrganization);
            const userRoles = (cov_14rmx9vrvj().s[18]++, allUserRoles[slug]);
            cov_14rmx9vrvj().s[19]++;
            resetMenus();
            cov_14rmx9vrvj().s[20]++;
            setOrganization(newOrganization);
            cov_14rmx9vrvj().s[21]++;
            requestLocations(consumerAPI);
            cov_14rmx9vrvj().s[22]++;
            requestOrgNetworkInterfaces();
            cov_14rmx9vrvj().s[23]++;
            if (userRoles) {
                cov_14rmx9vrvj().b[5][0]++;
                cov_14rmx9vrvj().s[24]++;
                setUserRoles(userRoles);
            }
            else {
                cov_14rmx9vrvj().b[5][1]++;
                cov_14rmx9vrvj().s[25]++;
                setUserRoles(ROLES.DEFAULT_PERMISSIONS);
            }
        }
        else {
            cov_14rmx9vrvj().b[4][1]++;
        }
    };
    cov_14rmx9vrvj().s[26]++;
    const redirectTo = route => {
        cov_14rmx9vrvj().f[7]++;
        cov_14rmx9vrvj().s[27]++;
        navigate(route);
    };
    cov_14rmx9vrvj().s[28]++;
    const renderMenuItems = () => {
        cov_14rmx9vrvj().f[8]++;
        cov_14rmx9vrvj().s[29]++;
        return sortedOrgs.map((value, index) => {
            cov_14rmx9vrvj().f[9]++;
            const { name } = (cov_14rmx9vrvj().s[30]++, value);
            cov_14rmx9vrvj().s[31]++;
            return React.createElement(Dropdown.Item, {
                key: index,
                onClick: () => {
                    cov_14rmx9vrvj().f[10]++;
                    cov_14rmx9vrvj().s[32]++;
                    return onOrganizationClick(index);
                }
            }, name);
        });
    };
    const availableOrgItems = (cov_14rmx9vrvj().s[33]++, organizations.length > 1 ? (cov_14rmx9vrvj().b[6][0]++, React.createElement(React.Fragment, null, React.createElement(Dropdown.Header, null, t('SWITCH_ORGANIZATION')), renderMenuItems())) : (cov_14rmx9vrvj().b[6][1]++, null));
    cov_14rmx9vrvj().s[34]++;
    return React.createElement("div", {
        id: "organizations-dropdown"
    }, React.createElement(DropdownButton, {
        align: "end",
        id: "organizations",
        variant: "outline-dark",
        title: name
    }, orgItems, availableOrgItems));
};
export default OrganizationsDropdown;
